export const bmp = 'image/bmp';
export const css = 'text/css';
export const csv = 'text/csv';
export const docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const gif = 'image/gif';
export const html = 'text/html';
export const js = 'text/javascript';
export const json = 'application/json';
export const jpeg = 'image/jpeg';
export const mp3 = 'audio/mp3';
export const mp4 = 'video/mp4';
export const mpeg = 'video/mpeg';
export const png = 'image/png';
export const pdf = 'application/pdf';
export const svg = 'image/svg+html';
export const tiff = 'image/tiff';
export const text = 'text/plain';
export const wav = 'audio/wav';
export const weba = 'audio/webm';
export const webm = 'video/webm';
export const webp = 'image/webp';
export const xml = 'text/xml';
export const xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const zip = ['application/zip', 'application/x-zip-compressed'];
export const sevenZip = 'application/x-7x-compressed';

export const audio = [mp3, wav, weba];
export const images = [bmp, gif, jpeg, png, tiff, webp];
export const video = [mp4, webm];
